function lockBodyScroll() {
  const scrollY = window.scrollY;
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  // if (scrollbarWidth > 0) {
  //   document.body.style.paddingRight = `${scrollbarWidth}px`;
  //   document.body.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
  // } else {
  //   document.body.style.setProperty('--scrollbar-width', '0px');
  // }

  document.body.style.top = `-${scrollY}px`;
  document.body.classList.add('body-lock-scroll');
  document.body.dataset.scrollY = scrollY;
}

function unlockBodyScroll() {
  if (!document.body.classList.contains('body-lock-scroll')) return;

  const scrollY = document.body.dataset.scrollY || '0';
  document.body.classList.remove('body-lock-scroll');
  document.body.style.top = '';
  // document.body.style.paddingRight = '';
  // document.body.style.removeProperty('--scrollbar-width');
  window.scrollTo(0, parseInt(scrollY));
  delete document.body.dataset.scrollY;
}
